module.exports = __webpack_public_path__ + "static/img/1_2_2_1.ac228885.jpg";